import { useRoute } from 'vue-router'
import type { FeedbackTopic } from '../../../core/models/feedback-topic'
import useGet from '../../../core/composables/api/useGet'
import { computed, toValue, watch, type MaybeRef } from 'vue'
import type { Skill } from '../../../core/models/skill'
import type { Scale } from '../../../core/models/scale'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../../../core/events/event-key'
import type { SurveySelectionPreview } from '@/modules/profile/composables/use-evaluation-profile'

export const usePrepareEvaluationSlide = (feedbackTopicId: MaybeRef<string>) => {
  const route = useRoute()

  const url = computed(() => {
    return `dialog/prepare/${route.params.id}/evaluation-slide/${toValue(feedbackTopicId)}`
  })

  const { data, load, status, reload } = useGet<DialogEvaluationSlide>(url)

  watch(url, () => {
    load()
  }, { immediate: true })

  const eventBus = useEventBus(EventKey.dialogSlideUpdated)
  eventBus.on(() => reload())

  return { data, status }
}

export interface DialogEvaluationSlide {
  readonly feedbackTopic: FeedbackTopic & { skills: ReadonlyArray<Skill> }
  readonly scale: Scale
  readonly surveys: ReadonlyArray<SurveySelectionPreview>
  readonly slideProperties: {
    readonly updatedAt: string | null
    readonly surveyIds: Array<string>
    readonly overestimateIds: Array<string>
    readonly potentialIds: Array<string>
    readonly strengthIds: Array<string>
    readonly underestimateIds: Array<string>
    readonly textIds: Array<string>
  }
}
